import type { CSSProperties } from 'react'

const paths = {
  grip: 'M9 5h.01 M15 5h.01 M9 12h.01 M15 12h.01 M9 19h.01 M15 19h.01',
  script: 'M14 2H4v20h16V8z M14 2v6h6 M10 12l-3 3 3 3 M14 12l3 3-3 3',
  sparkles: 'M12 3l2.3 6.7L21 12l-6.7 2.3L12 21l-2.3-6.7L3 12l6.7-2.3z M20 2v4 M18 4h4',
  archive: 'M3 3h18v5H3z M5 8v13h14V8 M9 12h6',
  filecheck: 'M14 2H4v20h16V8z M14 2v6h6 M8 15l3 3 5-6',
  usercheck: 'M15 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M12 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M16 10l2 2 4-4',
  sun: 'M12 3v1 M12 20v1 M3 12h1 M20 12h1 M5.6 5.6l.7.7 M17.7 17.7l.7.7 M5.6 18.4l.7-.7 M17.7 6.3l.7-.7 M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  moon: 'M20.5 13.2A8.5 8.5 0 0 1 10.8 3.5 8.5 8.5 0 1 0 20.5 13.2z',
  monitor: 'M3 4h18v13H3z M12 17v4 M8 21h8',
  play: 'M8 5l11 7-11 7z',
  pause: 'M8 5v14 M16 5v14',
  expand: 'M8 3H3v5 M16 3h5v5 M21 16v5h-5 M3 16v5h5',
  filter: 'M4 5h16 M7 12h10 M10 19h4',
  grid: 'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
  // A workflow: a stack of tasks. Templates use `template`, never this.
  layers: 'M12 2 2 7l10 5 10-5z M2 12l10 5 10-5 M2 17l10 5 10-5',
  // A template: the expert's experiment data dump (a data cylinder). Workflows use `layers`.
  template: 'M21 5a9 3 0 1 1-18 0 9 3 0 1 1 18 0 M3 5v14a9 3 0 0 0 18 0V5 M3 12a9 3 0 0 0 18 0',
  tasks: 'M9 5h12 M9 12h12 M9 19h12 M3 5h.01 M3 12h.01 M3 19h.01',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  people: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 3a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  mail: 'M3 5h18v14H3z M3 5l9 8 9-8',
  book: 'M12 5v16 M3 3h5a4 4 0 0 1 4 2 4 4 0 0 1 4-2h5v16h-5a4 4 0 0 0-4 2 4 4 0 0 0-4-2H3z',
  plus: 'M12 5v14 M5 12h14',
  arrow: 'M5 12h14 M13 6l6 6-6 6',
  file: 'M14 2H4v20h16V8z M14 2v6h6 M8 13h8 M8 17h5',
  folder: 'M3 7V5a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z',
  clock: 'M12 8v4l3 2 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  menu: 'M4 6h16 M4 12h16 M4 18h16',
  close: 'M6 6l12 12 M6 18 18 6',
  logout: 'M9 3H3v18h6 M9 12h12 M17 8l4 4-4 4',
  check: 'M5 12l4 4L19 6',
  chat: 'M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  chevron: 'M5 9l7 7 7-7',
  mic: 'M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0z M5 10v2a7 7 0 0 0 14 0v-2 M12 19v3 M8 22h8',
  paperclip: 'M21 11.5 11.5 21a6 6 0 0 1-8.5-8.5L13 2.5a4 4 0 0 1 5.7 5.7L8.6 18.3a2 2 0 0 1-2.8-2.8L15 6.3',
  send: 'M12 19V5 M5 12l7-7 7 7',
  download: 'M12 4v11 M7 11l5 5 5-5 M4 20h16',
  upload: 'M12 16V4 M7 9l5-5 5 5 M4 16v4h16v-4',
  pencil: 'M16 3l5 5 M3 21l5-1 13-13a3.5 3.5 0 0 0-5-5L3 15z',
  trash: 'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',

  activity: 'M22 12h-4l-3 9L9 3l-3 9H2',

  refresh: 'M21 12a9 9 0 1 1-3-6.7L21 8 M21 3v5h-5',

  zap: 'M13 2 4 14h6l-1 8 9-12h-6z',
  minus: 'M5 12h14',
  terminal: 'M4 17l6-5-6-5 M12 19h8',
  search: 'M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z M21 21l-4.35-4.35',
  list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
  info: 'M12 16v-4 M12 8h.01 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  alert: 'M12 3 2 20h20z M12 10v4 M12 17h.01',
  dollar: 'M12 2v20 M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  server: 'M3 4h18v6H3z M3 14h18v6H3z M7 7h.01 M7 17h.01',
  power: 'M12 3v9 M18.4 6.6a9 9 0 1 1-12.8 0',
  agent: 'M6 7h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3z M12 7V3 M8 12h.01 M16 12h.01 M9 17h6',
  // Wonky eyes, a tuft, and a tongue: the 'hand this to an agent' button.
  goofy: 'M19.6 13.5a7.6 7.6 0 1 1-15.2 0 7.6 7.6 0 0 1 15.2 0 M12.6 10a3.05 3.05 0 1 1-6.1 0 3.05 3.05 0 0 1 6.1 0 M18.2 10.9a2.45 2.45 0 1 1-4.9 0 2.45 2.45 0 0 1 4.9 0 M8.7 10.3h.01 M16.5 11.2h.01 M5.7 10.7C6 7 8.7 4.6 11.9 5.2 M11 5.4l1.6-2.5.3 2.7 2.3-1.6-.2 2.4 2.2-.5c.9.8 1.6 1.9 2 3 M8.8 15.7c1.7 1.3 4.3 1.4 6.2.2 M12.6 16.6v2a1.35 1.35 0 0 0 2.7 0v-2.4',
} as const

export type IconName = keyof typeof paths
export function Icon({ name, size = 18, style }: { name: IconName; size?: number; style?: CSSProperties }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={style}><path d={paths[name]} /></svg>
}
